import Cookies from 'js-cookie'
import { getSessionStorage  } from '@/utils/auth'

const app = {
  state: getSessionStorage('proappEnvLayout'),
}

export default app
